import { currentPosition } from '../../data/geocode';
import { btn, field, input } from '../../ui/components';
import { h } from '../../ui/dom';
/** No provider input accepted. Placement must be explicitly confirmed by the rep. */
export const manualPoint = () => {
  let confirmed: { lat: number; lng: number } | undefined;
  const message = h('p', { role: 'status' }, 'Optional: confirm the business door yourself.');
  const changed = () => {
    confirmed = undefined;
    message.textContent = 'Confirm coordinates before saving.';
  };
  const lat = input({ type: 'number', placeholder: 'Latitude', onInput: changed });
  const lng = input({ type: 'number', placeholder: 'Longitude', onInput: changed });
  lat.step = lng.step = 'any';
  const root = h(
    'details',
    {},
    h('summary', {}, 'Confirm location manually'),
    field('Latitude', lat),
    field('Longitude', lng),
    message,
    btn('Use my current location', {
      onClick: () => {
        void currentPosition().then((p) => {
          changed();
          if (!p) {
            message.textContent = 'Device location unavailable';
            return;
          }
          lat.value = String(p.lat);
          lng.value = String(p.lng);
        });
      },
    }),
    btn('Confirm coordinates', {
      onClick: () => {
        const pair = { lat: Number(lat.value), lng: Number(lng.value) };
        if (
          !lat.value.trim() ||
          !lng.value.trim() ||
          !Number.isFinite(pair.lat) ||
          !Number.isFinite(pair.lng) ||
          Math.abs(pair.lat) > 90 ||
          Math.abs(pair.lng) > 180
        ) {
          message.textContent = 'Enter valid coordinates';
          return;
        }
        confirmed = pair;
        message.textContent = 'Manual placement confirmed';
      },
    }),
  );
  return { root, get: () => confirmed };
};
